export const requestTypes = [
  {
    code: "QUOTATION",
    name: "Quotation"
  },
  {
    code: "GENERATION",
    name: "Generation"
  },
  {
    code: "DOWNLOAD",
    name: "Download"
  }
];

export const initialFilters = {
  requestType: null,
  insurers: null
};
